import type { RawSession } from '@pp/toolkit';

export interface ILoaderConfig {
  baseUrl: string;
  loaderVersion: string;
  gameType: string;
  buildType: string;
  disableLoader: boolean;
  isProdVersion: boolean;
  casinoId: string;
  session?: RawSession | null;
}

export enum SESSION_KEYS {
  LOBBY = 'PPG_L',
  GAME = 'PPG',
}

export interface IPackageConfig {
  url: string;
  version: string;
  type?: string;
  files: {
    js?: string[];
    css?: string[];
    releaseData?: boolean;
    doNotResolve?: boolean;
  };
}
